import React from 'react';
import Button from '../../../../composants/Button/Button';
import type { AutoSaveStatus } from '../../../../hooks/useAutoSave';
import './BottomActionBar.css';

interface BottomActionBarProps {
  onQuitter: () => void;
  onDeposer: () => void;
  canDeposer: boolean;
  estMandataire: boolean;
  saveStatus?: AutoSaveStatus;
  saveError?: string | null;
  onPreviewPdf?: () => void;
  isGeneratingPdf?: boolean;
  canPreviewPdf?: boolean;
}

const BottomActionBar: React.FC<BottomActionBarProps> = ({
  onQuitter,
  onDeposer,
  canDeposer,
  estMandataire,
  saveStatus = 'idle',
  saveError,
  onPreviewPdf,
  isGeneratingPdf,
  canPreviewPdf,
}) => {
  const renderSaveIndicator = () => {
    switch (saveStatus) {
      case 'saving':
        return (
          <div className="bottom-save-indicator bottom-save-indicator--saving">
            <span className="bottom-save-spinner" />
            <span>Enregistrement</span>
          </div>
        );
      case 'saved':
        return (
          <div className="bottom-save-indicator bottom-save-indicator--saved">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8.5L6.5 12L13 4" stroke="#16a34a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            <span>Enregistré</span>
          </div>
        );
      case 'pending':
        return (
          <div className="bottom-save-indicator bottom-save-indicator--pending">
            <span>Modifications non enregistrées</span>
          </div>
        );
      case 'error':
        return (
          <div className="bottom-save-indicator bottom-save-indicator--error">
            <span>Erreur{saveError ? ` — ${saveError}` : ''}</span>
          </div>
        );
      default:
        return <div className="bottom-save-indicator" />;
    }
  };

  return (
    <>
      <div className="bottom-action-bar">
        {estMandataire && renderSaveIndicator()}
        <div className="bottom-action-bar__actions">
          <Button
            variant="secondary"
            value={estMandataire ? "Enregistrer et quitter" : "Retour"}
            size='small'
            onClick={onQuitter}
            className="bottom-action-bar__btn"
          />
          {onPreviewPdf && (
            <Button
              variant="secondary"
              value={isGeneratingPdf ? 'Génération en cours…' : 'Prévisualiser le contrat'}
              disabled={isGeneratingPdf || !canPreviewPdf}
              onClick={onPreviewPdf}
              size='small'
              className="bottom-action-bar__btn"
            />
          )}
          {estMandataire && (
            <Button
              variant="primary"
              value="Déposer mon offre"
              disabled={!canDeposer}
              onClick={onDeposer}
              size='small'
              className="bottom-action-bar__btn"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default BottomActionBar;
